import React from 'react'
import styled from 'styled-components'
import { connect } from 'react-redux'
import ReactHtmlParser from 'react-html-parser';

class PromotionDataConfirmationComponent extends React.Component {
	constructor(props) {
		super(props)
	}

	render() {
		return (
			<StyledContainer>
				{ReactHtmlParser(this.props.message)}
			</StyledContainer>
		)
	}
}

const StyledContainer = styled.div``

const mapStateToProps = store => ({})

const PromotionDataConfirmation = connect(mapStateToProps)(
	PromotionDataConfirmationComponent
)

export default PromotionDataConfirmation
